module.exports = __webpack_public_path__ + "static/media/section-three.9cf2f220.png";